export default __webpack_public_path__ + "static/media/Full cat.87a1e104.svg";